import clsx from 'clsx';
import { ReactNode } from 'react';
import { FreddieNavLogo } from './FreddieNavLogo';

export type HeaderProps = {
  leftControl?: ReactNode;
  rightControl?: ReactNode;
  hideOnWideScreen?: boolean;
};

const Header = ({
  leftControl,
  rightControl,
  hideOnWideScreen = false,
}: HeaderProps) => {
  return (
    <nav>
      <div
        className={clsx(
          'flex h-16 items-center bg-white shadow-xs px-s',
          hideOnWideScreen && 'md:hidden',
        )}
      >
        {leftControl}
        <div className="flex shrink-0 grow justify-center">
          <FreddieNavLogo />
        </div>
        {rightControl}
      </div>
    </nav>
  );
};

export default Header;
